<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import config from "../../config.js";
import { confirmAlert } from "../../plugins/alert";

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    item:{
      type:Object,
      required:true,
    },
    identityId:{
      type:Number,
      required:true,
    },
    fields:{
      type:Array,
      required:true,
    },
    deleteItemComplete:{
      type:Function
    }
})
const deleteOrder = async (item) => {
  let resultConfirm = await confirmAlert('本当に削除しますか？');
  if (resultConfirm.isConfirmed) {
    if (typeof props.deleteItemComplete !== 'undefined') {
      props.deleteItemComplete(item);
    }
  }
}

</script>

<style scoped>
</style>
<template>
<td v-for="(field,index) in fields" :key="index" :style="'width:' + field.width" class="text-center">
  <div v-if="field.field_key == 'product_detail_name'" class="text-left">
    {{ item.product_name + ' ' + item.package_label }}<span v-html="item.warning_mark"></span>
  </div>
  <div v-else-if="field.field_key == 'stock_type'">
    <span v-show="item.stock_type == config.STOCK_TYPES['VAN']" class="label-van">卸</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['小分け']" class="label-pack">小分け</span>
  </div>
  <div v-else-if="field.field_key == 'order_number'">
    <div v-if="item.stock_type == config.STOCK_TYPES['VAN']">
      {{ item.order_number.toLocaleString() }}({{ item.order_detail_number.toLocaleString() + item.package_unit }})
    </div>
    <div v-else>
      {{ item.order_number.toLocaleString() + item.package_unit }}
    </div>
  </div>
  <div v-else-if="field.field_key == 'stock_number'" class="flex flex-col items-center">
    <div :class="(item.real_stock_number != item.stock_number ? ' text-red-700 text-bold ' : '')">{{ item.stock_number.toLocaleString() + item.package_unit }}</div>
  </div>
  <div v-else-if="field.field_key == 'real_stock_number'" class="flex flex-col items-center">
    <div >{{ item.real_stock_number.toLocaleString() + item.package_unit }}</div>
  </div>
  <div v-else-if="field.field_key == 'unit_price'">
    <div class="flex flex-row items-center"><div>\{{ item.unit_price.toLocaleString() }}</div> <div class="ml-1" v-show="item.expensive_alert"><img class="w-6 h-6" src="../../../public/images/icon/expensive_alert.png"></div></div>
  </div>
  <div v-else-if="field.field_key == 'current_package_price'">
    <div class="flex flex-row items-center"><div>\{{ item.current_package_price.toLocaleString() }}</div> <div class="ml-1" v-show="item.expensive_alert"><img class="w-6 h-6" src="../../../public/images/icon/expensive_alert.png"></div></div>
  </div>
  <div v-else-if="field.field_key == 'total_price'">
    \{{ item.total_price.toLocaleString() }}
  </div>
  <div v-else-if="field.field_key == 'action'">
    <a href="javascript:void(0)" class="text-lg" @click="deleteOrder(item)"><i class="fa-solid fa-delete-left"></i></a>
  </div>
  <div v-else :class="field.align">
    {{ item[field.field_key] }}
  </div>
</td>
</template>

